// import { axiosClient } from "../../../../utils/auth.util";
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import "./TutorExam.css";
// import Loader1 from "../../Components/LinearLoder";
// import { Radio, Box, Fade, Button, Stack } from "@mui/material";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import InitialWarningDialog from './InitialWarningDialog'

// import { useDispatch } from "react-redux";
// import { setFrom } from "../../../../redux/slice/tutorExamSlice";
// // Removed direct axios import; using axiosClient from auth.util.js

// const TutorExam = (props) => {
//   // let subjectList=['Soil Mechanics','Mass Transfer','Business Math','Physical chemistry']

//   const dispatch = useDispatch();

//   const [base64, setBase64] = useState([]);
//   const [answer, setAnswer] = useState({});
//   const [showTimer, setShowTimer] = useState(false);

//   const [timeEnds, setTimeEnds] = useState(false);
//   const [isPage, setIsPage] = useState(true);
//   const [loaderVisible, setLoaderVisible] = useState(false);
//   const [showNumbers, setShowNumbers] = useState(false);
//   const [status, setStatus] = useState("");
//   const { initialMinute = props.timeOfTest, initialSeconds = 0 } = props;

//   const [minutes, setMinutes] = useState(initialMinute || 40);
//   const [seconds, setSeconds] = useState(initialSeconds);
//   const [tickedAnswer, setTickedAnswer] = useState([]);

//   // const [keyArray,setKeyArray]=useState()
//   const history = useNavigate();
//   const [isVisibleQuestion, setIsVisibleQuestion] = useState(1);
//   const [showInitialWarningDialog, setShowInitialWarningDialog] =
//   useState(true);


//   useEffect(() => {
//     let myInterval = setInterval(() => {
//       if (seconds > 0) {
//         setSeconds(seconds - 1);
//       }
//       if (seconds === 0) {
//         if (minutes === 0) {
//           clearInterval(myInterval);
//           setTimeEnds(true);
//         } else {
//           setMinutes(minutes - 1);
//           setSeconds(59);
//         }
//       }
//     }, 1000);
//     return () => {
//       clearInterval(myInterval);
//     };
//   });

//   // const handleClick=(e)=>{
//   //   let val;
//   //   let name=e.target.name;
//   //   if(e.target.value===answer[e.target.name]){
//   //     val=""
//   //   }else{
//   //     val= e.target.value;
//   //   }
//   //   console.log({temp_val:val})
//   //   let inputObj = {};
//   //   // setInputId(name);
//   //   inputObj[name] = val;
//   //   // setAnswer({ ...answer, ...inputObj });
//   //   setAnswer({ ...answer, ...inputObj });
//   // }

//   const changeHandler = (e) => {
//     let val;
//     let name = e.target.name;
//     console.log({
//       val: e.target.value,
//       answe: answer[name],
//       name: e.target.name,
//     });
//     if (e.target.value === answer[e.target.name]) {
//       val = null;
//     } else {
//       val = e.target.value;
//     }

//     let key = e.target.key;
//     // const regMatch = /^[a-dA-D]*$/.test(val);

//     // if (val.length <= 1 && regMatch) {
//     // val = val.toUpperCase();
//     let Id = e.target.id;
//     console.log({ targetName: name });
//     console.log({ ID_test: key });
//     let inputObj = {};
//     // setInputId(name);
//     inputObj[name] = val;
//     setTickedAnswer((prev) => [...prev, Number(name)]);
//     // setAnswer({ ...answer, ...inputObj });
//     setAnswer({ ...answer, ...inputObj });
//     // setAnswerObject()

//     // }
//   };
//   // console.log({ answer });

//   const re_attempt = useCallback(async () => {
//     const response = await axiosClient.post(
//       "/tutorweb/find_examId",
//       { tutorId: props.tutorId }
//     );

//     if (response.status === 201 || response.status === 200) {
//       const sublist = [];
//       sublist.push(response.data.lastSubject);
//       try {
//         const getQues = await axiosClient.post(
//           "/tutorweb/get_questions",
//           { subjectList: sublist }
//         );

//         if (getQues?.data?.questionArr?.length !== 0) {
//           let keys = getQues.data.keyArr;
//           console.log({ keys });

//           let getQuesAr = getQues.data.questionArr;
//           let base64String = [];
//           getQuesAr.map((el) => {
//             return base64String.push(
//               btoa(
//                 new Uint8Array(el.data).reduce(function (data, byte) {
//                   return data + String.fromCharCode(byte);
//                 }, "")
//               )
//             );
//           });

//           setBase64(base64String);
//           setIsPage(false);
//         }
//       } catch (error) {
//         console.log(error, "inside if block");
//       }
//     }
//   }, [props]);

//   useEffect(() => {
//     if (!isPage && props.tutorId) {
//       re_attempt();
//     }
//   }, [isPage, re_attempt, props]);

//   const get_questions = useCallback(async () => {
//     console.log({ subjectList: props.subjectList });
//     //   const getQues=await Axios.post("https://device2api.el.r.appspot.com/tutor/get_questions",{subjectList:props.subjectList});

//     //   if (getQues?.data?.questionArr?.length!==0){
//     //     console.log({getQues:getQues.data.questionArr})
//     //     let keys=getQues.data.keyArr
//     //     setKeyArray(getQues.data.keyArr)
//     //     console.log({keys})

//     //     let getQuesAr=getQues.data.questionArr;
//     //     let base64String=[];
//     //     getQuesAr.map((el)=>{

//     //      base64String.push(btoa(String.fromCharCode(...new Uint8Array(el.data))));
//     //     // const base64String = new Buffer.from(getQues.data.questionArr.data).toString("ascii")

//     //   })
//     // console.log({base64String});
//     setBase64(props.currentBase64);
//     // }
//     // else{
//     //   console.log({getQues:"not Found"})
//     // }
//   }, [props.currentBase64, props.subjectList]);

//   const submitHandler = useCallback(async () => {
//     let answerObj = [];
//     setLoaderVisible(true);
//     props.keyArSend.map((el3, index) => {
//       let oneObject = { Key: "", Answer: "", Subject: "" };
//       oneObject.Key = el3[0];
//       oneObject.Subject = el3[1];
//       oneObject.Answer = answer[index + 1];
//       answerObj.push(oneObject);
//     });
//     console.log({ answerObj });
//     const getSheet = await axiosClient.post(
//       "/tutorweb/get_sheet",
//       {
//         answerObj,
//         subjectList: props.subjectList,
//         tutorId: props.tutorId,
//         examId: props.examId,
//       }
//     );

//     if (getSheet.data.success === true) {
//       // alert("Congrats!!!You passed the test")
//       // setMinutes(0)
//       // setSeconds(0)
//       let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//       let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;
//       let tutor_exam_temp = JSON.parse(localStorage.getItem("tutor"))?.saveTutor
//         ?.tutor_exam
//         ? JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_exam
//         : [];

//       if (getSheet.data.status === "pass") {
//         // setCurrentQuestionSet((prev) => prev + 1);

//         setStatus("pass");
//         dispatch(setFrom("objective"));
//         let tagsAr = [...tutor_ls.tags, getSheet?.data?.subject];

//         let tutor_exam_obj = {
//           exam_id: getSheet?.data?.exam_id,
//           subject: getSheet?.data?.subject,
//           marks: getSheet?.data?.result,
//           passing_marks: getSheet?.data?.passing_marks,
//           status: getSheet?.data?.status,
//         };

//         let temp_tutorSaveObj = {
//           ...tutor_ls,
//           tutStatus: "mcqe",
//           tags: tagsAr,
//           tutor_exam: [...tutor_exam_temp, tutor_exam_obj],
//         };
//         console.log({ tutor_ls });
//         let temp_tutorObj = {
//           ...tutor1,
//           saveTutor: temp_tutorSaveObj,
//         };
//         // let tutor_stringified = JSON.stringify(temp_tutorObj);
//         // localStorage.setItem("tutor", tutor_stringified);
//         props.setLocalSt(temp_tutorObj);
//         const tutorRatingVal = await axiosClient.get(
//           `/tutorweb/getTutorRating/${
//             JSON.parse(localStorage.getItem("tutor"))?.saveTutor?.tutor_id
//           }`
//         );
//         // props.setTemp_tutExam(temp_tutorObj)
//         const ratingVal = tutorRatingVal?.data?.ratingVal;
//         console.log({ ratingVal });
//         let marksVal = +getSheet?.data?.result * 4;
//         let initialRating = ratingVal
//           ? marksVal > 70 && marksVal <= 75
//             ? (+tutor_ls?.rating + 6) / 2
//             : marksVal > 75 && marksVal <= 80
//             ? (+ratingVal + 7) / 2
//             : marksVal > 80 && marksVal <= 85
//             ? (+ratingVal + 8) / 2
//             : marksVal > 85 && marksVal <= 90
//             ? (+ratingVal + 9) / 2
//             : marksVal > 90
//             ? (+ratingVal + 10) / 2
//             : +ratingVal
//           : marksVal > 70 && marksVal <= 75
//           ? 6
//           : marksVal > 75 && marksVal <= 80
//           ? 7
//           : marksVal > 80 && marksVal <= 85
//           ? 8
//           : marksVal > 85 && marksVal <= 90
//           ? 9
//           : marksVal > 90
//           ? 10
//           : null;
//         // console.log({tutor_ls , marksVal , initialRating})
//         const res = await axiosClient.post(
//           `/tutorweb/setDetailsAfterExamDone/${
//             JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id
//           }`,
//           {
//             email: tutor_ls?.email,
//             name: tutor_ls?.name,
//             dept: tutor_ls?.dept,
//             highest_degree: tutor_ls?.highest_degree,
//             university: tutor_ls?.academic_info[0]?.college,
//             skills: tutor_ls?.skills,
//             best_subjects: tutor_ls?.best_subjects,
//             wa_id: tutor_ls?.wa_id,
//             software_skills: tutor_ls?.software_skills,
//             tutStatus: "mcqe",
//             rating: initialRating ? initialRating?.toFixed(2) + "" : null,
//             tags: tagsAr,
//           }
//         );
//       } else {
//         // setCurrentQuestionSet(2);
//         // setCurrentQuestionSet((prev) => prev + 1);

//         // dispatch(setResultStatus("fail"));
//         setStatus("fail");

//         let tutor_exam_obj = {
//           exam_id: getSheet?.data?.exam_id,
//           subject: getSheet?.data?.subject,
//           marks: getSheet?.data?.result,
//           passing_marks: getSheet?.data?.passing_marks,
//           status: getSheet?.data?.status,
//         };

//         let temp_tutorSaveObj = {
//           ...tutor_ls,
//           tutStatus: "mcqe",
//           tutor_exam: [...tutor_exam_temp, tutor_exam_obj],
//         };
//         console.log({ tutor_ls });
//         let temp_tutorObj = {
//           ...tutor1,
//           saveTutor: temp_tutorSaveObj,
//         };
//         // let tutor_stringified = JSON.stringify(temp_tutorObj);
//         // localStorage.setItem("tutor", tutor_stringified);
//         // props.setTemp_tutExam(temp_tutorObj)
//         props.setLocalSt(temp_tutorObj);
//       }
//       history("/register-dashboard/tutor_exam/submitted");
//       setShowTimer(false);
//       setLoaderVisible(false);
//       props.setResult_func(getSheet.data.result);
//       props.setResultStatus_func(getSheet.data.status);
//       props.setSubject_func(getSheet.data.subject);
//       // setExamDone(true)
//       console.log({ marks: getSheet.data.result });
//       // setMarks(getSheet.data.result);
//     } else {
//       setMinutes(0);
//       setSeconds(0);
//       // setExamDone(false)
//       setLoaderVisible(false);
//       alert("something went wrong!!");
//     }
//   }, [answer, history, props, dispatch]);

//   const closeWarning = () => {
//     setShowInitialWarningDialog(false);
//   };

//   useEffect(() => {
//     function handleVisibilityChange() {
//       if (
//         document.visibilityState !== "visible" ||
//         document.visibilityState === "hidden"
//       ) {
//         console.log("hit");
//         submitHandler();
//       }
//     }

//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, [submitHandler]);

//   useEffect(() => {
//     // setCount("1")
//     if (props.currentBase64.length !== 0) {
//       setIsPage(true);
//       get_questions();
//     } else {
//       setIsPage(false);
//       history("/register-dashboard/tutor_exam",{replace:true});
//     }
//   }, [get_questions, props.currentBase64.length, history]);

//   useEffect(() => {
//     // setCount("1")
//     if (minutes === 0 && seconds === 0) {
//       submitHandler();
//     }
//   }, [timeEnds, minutes, seconds, submitHandler]);

//   return (
//     <>
//       {loaderVisible && <Loader1 />}
//       {/* here place the subject part */}
//       {showInitialWarningDialog && (
//             <InitialWarningDialog
//               showInitialWarningDialog={showInitialWarningDialog}
//               setShowInitialWarningDialog={setShowInitialWarningDialog}
//               submitHandler={closeWarning}
//             />
//           )}
//       <div style={{ marginTop: "5.5rem" }}>
//         <div id="countdown">
//           {minutes === 0 && seconds === 0 ? (
//             <div className="timer-cont">
//               <div className="timer">
//                 <AccessAlarmIcon sx={{ fontSize: "30px" }} />
//               </div>
//               <div className="minutes">
//                 <div className="c-number">00:</div>
//               </div>
//               <div className="minutes">
//                 <div className="c-number">00:</div>
//               </div>

//               <div className="seconds">
//                 <div className="c-number">00 </div>
//               </div>
//             </div>
//           ) : (
//             <div className="timer-cont">
//               <div className="timer">
//                 <AccessAlarmIcon sx={{ fontSize: "30px" }} />
//               </div>
//               <div className="minutes">
//                 <div className="c-number">00:</div>
//               </div>
//               <div className="minutes">
//                 <div className="c-number">{minutes}:</div>
//               </div>
//               <div className="seconds">
//                 <div className="c-number">
//                   {seconds < 10 ? `0${seconds}` : seconds}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         <div class="button-container">
//           <div
//             style={{ textAlign: "left", dataAlign: "right" }}
//             class="form-buttons-wrapper form-buttons-center   jsTest-button-wrapperField"
//           >
//             <Button
//               onClick={() => setShowNumbers((prev) => !prev)}
//               variant="outlined"
//             >
//               {showNumbers ? "Hide" : "Show"}
//               {showNumbers ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//             </Button>
//           </div>
//           <div
//             style={{ textAlign: "right", dataAlign: "right" }}
//             class="form-buttons-wrapper form-buttons-center   jsTest-button-wrapperField"
//           >
//             <Stack flexDirection="row" gap={2}>
//               <Button type="button" variant="contained" onClick={submitHandler}>
//                 Submit
//               </Button>
//             </Stack>
//           </div>
//         </div>
//         {showNumbers && (
//           <Box sx={{ display: "flex" }}>
//             <Fade in={showNumbers}>
//               <div className="answer-check-container">
//                 {base64.map((el, i) => (
//                   <button
//                     key={i}
//                     className={
//                       tickedAnswer.includes(i + 1)
//                         ? "answer-check"
//                         : "answer-uncheck"
//                     }
//                     onClick={() => setIsVisibleQuestion(i + 1)}
//                   >
//                     {i + 1}
//                   </button>
//                 ))}
//               </div>
//             </Fade>
//           </Box>
//         )}
//       </div>

//       <div>
//         <div role="main" class="form-all form-all-cont form-desc-tutExam">
//           <ul class="form-section page-section">
//             {base64.map((el1, i) => {
//               if (i + 1 === isVisibleQuestion) {
//                 return (
//                   <div>
//                     <li
//                       class="form-line"
//                       data-type="control_textarea"
//                       id="id_6"
//                     >
//                       <label
//                         class="form-label form-label-top form-label-auto"
//                         id="label_6"
//                         for="input_6"
//                         style={{ fontWeight: "bold" }}
//                       >
//                         {" "}
//                         Question {i + 1}
//                       </label>
//                       <div id="cid_6" class="form-input-wide">
//                         <img
//                           src={`data:image/jpeg;base64,${el1}`}
//                           alt=""
//                           style={{ width: "-webkit-fill-available" }}
//                         />

//                         <FormControl>
//                           <RadioGroup
//                             row
//                             aria-labelledby="demo-controlled-radio-buttons-group"
//                             name={i + 1}
//                             onChange={changeHandler}
//                             value={answer[`${i + 1}`]}
//                             style={{
//                               marginLeft: "10px",
//                               marginTop: "25px",
//                               marginBottom: "-25px",
//                             }}
//                           >
//                             <FormControlLabel
//                               value="A"
//                               control={<Radio />}
//                               label="A"
//                             />
//                             <FormControlLabel
//                               value="B"
//                               control={<Radio />}
//                               label="B"
//                             />
//                             <FormControlLabel
//                               value="C"
//                               control={<Radio />}
//                               label="C"
//                             />
//                             <FormControlLabel
//                               value="D"
//                               control={<Radio />}
//                               label="D"
//                             />
//                           </RadioGroup>
//                         </FormControl>
//                       </div>
//                     </li>
//                     <li
//                       class="form-line"
//                       data-type="control_divider"
//                       id="id_34"
//                     >
//                       <div id="cid_34" class="form-input-wide">
//                         <div
//                           class="divider"
//                           aria-label="Divider"
//                           data-component="divider"
//                           style={{
//                             borderBottomWidth: "1px",
//                             borderBottomStyle: "solid",
//                             borderColor: "#e6e6e6",
//                             height: "1px",
//                             marginLeft: "0px",
//                             marginRight: "0px",
//                             marginTop: "5px",
//                             marginBottom: "5px",
//                           }}
//                         ></div>
//                       </div>
//                     </li>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                       }}
//                     >
//                       <Button
//                         variant="outlined"
//                         disabled={isVisibleQuestion === 1}
//                         onClick={() => setIsVisibleQuestion((prev) => prev - 1)}
//                       >
//                         Previous
//                       </Button>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => setIsVisibleQuestion((prev) => prev + 1)}
//                         disabled={isVisibleQuestion === base64.length}
//                       >
//                         Next
//                       </Button>
//                     </div>
//                   </div>
//                 );
//               } else {
//                 return <></>;
//               }
//             })}
//           </ul>
//         </div>
//       </div>

//       {!isPage && (
//         <div style={{ textAlign: "center", marginTop: "10%" }}>
//           <h1 style={{ color: "black" }}>404</h1>
//           <h1 style={{ color: "black" }}>Not Found</h1>
//           <br />
//           <h3 style={{ color: "black" }}>Invalid Grant!!</h3>
//         </div>
//       )}
//     </>
//   );
// };

// export default TutorExam;



import { axiosClient } from "../../../../utils/auth.util";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./TutorExam.css";
import Loader1 from "../../Components/LinearLoder";
import { Radio, Box, Fade, Button, Stack } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InitialWarningDialog from './InitialWarningDialog';
import { useDispatch } from "react-redux";
import { setFrom } from "../../../../redux/slice/tutorExamSlice";
import { updateUserData } from "../../../../redux/slice/registerSlice";

const TutorExam = (props) => {
  const dispatch = useDispatch();
  const [base64, setBase64] = useState([]);
  const [answer, setAnswer] = useState({});
  const [showTimer, setShowTimer] = useState(false);
  const [timeEnds, setTimeEnds] = useState(false);
  const [isPage, setIsPage] = useState(true);
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [showNumbers, setShowNumbers] = useState(false);
  const [status, setStatus] = useState("");
  const { initialMinute = props.timeOfTest, initialSeconds = 0 } = props;
  const [minutes, setMinutes] = useState(initialMinute || 40);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [tickedAnswer, setTickedAnswer] = useState([]);
  const history = useNavigate();
  const [isVisibleQuestion, setIsVisibleQuestion] = useState(1);
  const [showInitialWarningDialog, setShowInitialWarningDialog] = useState(true);

  // Get userData from props instead of localStorage
  const { userData, tutorId, examId } = props;

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
          setTimeEnds(true);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const changeHandler = (e) => {
    let val;
    let name = e.target.name;

    console.log({
      val: e.target.value,
      answe: answer[name],
      name: e.target.name,
    });

    if (e.target.value === answer[e.target.name]) {
      val = null;
    } else {
      val = e.target.value;
    }

    let key = e.target.key;
    let Id = e.target.id;
    console.log({ targetName: name });
    console.log({ ID_test: key });
    let inputObj = {};
    inputObj[name] = val;
    setTickedAnswer((prev) => [...prev, Number(name)]);
    setAnswer({ ...answer, ...inputObj });
  };

  const re_attempt = useCallback(async () => {
    const response = await axiosClient.post(
      "/tutorweb/find_examId",
      { tutorId: tutorId }
    );

    if (response.status === 201 || response.status === 200) {
      const sublist = [];
      sublist.push(response.data.lastSubject);

      try {
        const getQues = await axiosClient.post(
          "/tutorweb/get_questions",
          { subjectList: sublist }
        );

        if (getQues?.data?.questionArr?.length !== 0) {
          let keys = getQues.data.keyArr;
          console.log({ keys });
          let getQuesAr = getQues.data.questionArr;
          let base64String = [];

          getQuesAr.map((el) => {
            return base64String.push(
              btoa(
                new Uint8Array(el.data).reduce(function (data, byte) {
                  return data + String.fromCharCode(byte);
                }, "")
              )
            );
          });

          setBase64(base64String);
          setIsPage(false);
        }
      } catch (error) {
        console.log(error, "inside if block");
      }
    }
  }, [tutorId]);

  useEffect(() => {
    if (!isPage && tutorId) {
      re_attempt();
    }
  }, [isPage, re_attempt, tutorId]);

  const get_questions = useCallback(async () => {
    console.log({ subjectList: props.subjectList });
    setBase64(props.currentBase64);
  }, [props.currentBase64, props.subjectList]);

  const submitHandler = useCallback(async () => {
    let answerObj = [];
    setLoaderVisible(true);

    props.keyArSend.map((el3, index) => {
      let oneObject = { Key: "", Answer: "", Subject: "" };
      oneObject.Key = el3[0];
      oneObject.Subject = el3[1];
      oneObject.Answer = answer[index + 1];
      answerObj.push(oneObject);
    });

    console.log({ answerObj });

    const getSheet = await axiosClient.post("/tutorweb/get_sheet", {
      answerObj,
      subjectList: props.subjectList,
      tutorId: tutorId,
      examId: examId,
    });

    if (getSheet.data.success === true) {
      if (getSheet.data.status === "pass") {
        setStatus("pass");
        dispatch(setFrom("objective"));

        // Create exam result object
        let examResult = {
          exam_id: getSheet?.data?.exam_id,
          subject: getSheet?.data?.subject,
          marks: getSheet?.data?.result,
          passing_marks: getSheet?.data?.passing_marks,
          status: getSheet?.data?.status,
        };

        // Update Redux state instead of localStorage
        const updatedTags = [...(userData.tags || []), getSheet?.data?.subject];
        const updatedExams = [...(userData.tutor_exam || []), examResult];

        dispatch(updateUserData({
          tutStatus: "mcqe",
          tags: updatedTags,
          tutor_exam: updatedExams,
        }));

        // Get tutor rating and calculate new rating
        const tutorRatingVal = await axiosClient.get(
          `/tutorweb/getTutorRating/${tutorId}`
        );

        const ratingVal = tutorRatingVal?.data?.ratingVal;
        console.log({ ratingVal });
        let marksVal = +getSheet?.data?.result * 4;
        let initialRating = ratingVal
          ? marksVal > 70 && marksVal <= 75
            ? (+ratingVal + 6) / 2
            : marksVal > 75 && marksVal <= 80
            ? (+ratingVal + 7) / 2
            : marksVal > 80 && marksVal <= 85
            ? (+ratingVal + 8) / 2
            : marksVal > 85 && marksVal <= 90
            ? (+ratingVal + 9) / 2
            : marksVal > 90
            ? (+ratingVal + 10) / 2
            : +ratingVal
          : marksVal > 70 && marksVal <= 75
          ? 6
          : marksVal > 75 && marksVal <= 80
          ? 7
          : marksVal > 80 && marksVal <= 85
          ? 8
          : marksVal > 85 && marksVal <= 90
          ? 9
          : marksVal > 90
          ? 10
          : null;

        // Update backend
        const res = await axiosClient.post(
          `/tutorweb/setDetailsAfterExamDone/${tutorId}`,
          {
            email: userData?.email,
            name: userData?.fullName || userData?.name,
            dept: userData?.department,
            highest_degree: userData?.highest_degree,
            university: userData?.academic_info?.[0]?.college,
            skills: userData?.skills,
            best_subjects: userData?.best_subjects,
            wa_id: userData?.whatsappNumber?.number,
            software_skills: userData?.software_skills,
            tutStatus: "mcqe",
            rating: initialRating ? initialRating?.toFixed(2) + "" : null,
            tags: updatedTags,
          }
        );
      } else {
        setStatus("fail");
        
        let examResult = {
          exam_id: getSheet?.data?.exam_id,
          subject: getSheet?.data?.subject,
          marks: getSheet?.data?.result,
          passing_marks: getSheet?.data?.passing_marks,
          status: getSheet?.data?.status,
        };

        // Update Redux state for failed exam
        const updatedExams = [...(userData.tutor_exam || []), examResult];

        dispatch(updateUserData({
          tutStatus: "mcqe",
          tutor_exam: updatedExams,
        }));
      }

      history("/register-dashboard/tutor_exam/submitted");
      setShowTimer(false);
      setLoaderVisible(false);
      props.setResult_func(getSheet.data.result);
      props.setResultStatus_func(getSheet.data.status);
      props.setSubject_func(getSheet.data.subject);
    } else {
      setMinutes(0);
      setSeconds(0);
      setLoaderVisible(false);
      alert("something went wrong!!");
    }
  }, [answer, history, props, dispatch, userData, tutorId, examId]);

  const closeWarning = () => {
    setShowInitialWarningDialog(false);
  };

  useEffect(() => {
    function handleVisibilityChange() {
      if (
        document.visibilityState !== "visible" ||
        document.visibilityState === "hidden"
      ) {
        console.log("hit");
        submitHandler();
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [submitHandler]);

  useEffect(() => {
    if (props.currentBase64.length !== 0) {
      setIsPage(true);
      get_questions();
    } else {
      setIsPage(false);
      history("/register-dashboard/tutor_exam", { replace: true });
    }
  }, [get_questions, props.currentBase64.length, history]);

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      submitHandler();
    }
  }, [timeEnds, minutes, seconds, submitHandler]);

  return (
    <>
      {loaderVisible && <Loader1 />}
      {showInitialWarningDialog && (
        <InitialWarningDialog
          open={showInitialWarningDialog}
          onClose={closeWarning}
        />
      )}

      <div className="tutor-exam-container">
        <div className="exam-header">
          <div className="timer-section">
            <AccessAlarmIcon />
            <span>
              {minutes === 0 && seconds === 0 ? null : (
                <>
                  {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </>
              )}
            </span>
          </div>
        </div>

        <div className="questions-container">
          {base64.map((el1, i) => {
            if (i + 1 === isVisibleQuestion) {
              return (
                <Fade in={true} key={i}>
                  <Box className="question-box">
                    <div className="question-number">
                      Question {i + 1} of {base64.length}
                    </div>
                    
                    <div className="question-image">
                      <img
                        src={`data:image/png;base64,${el1}`}
                        alt={`Question ${i + 1}`}
                        style={{ maxWidth: "100%", height: "auto" }}
                      />
                    </div>

                    <FormControl component="fieldset" className="options-container">
                      <RadioGroup
                        name={`${i + 1}`}
                        value={answer[i + 1] || ""}
                        onChange={changeHandler}
                      >
                        <FormControlLabel
                          value="A"
                          control={<Radio />}
                          label="A"
                        />
                        <FormControlLabel
                          value="B"
                          control={<Radio />}
                          label="B"
                        />
                        <FormControlLabel
                          value="C"
                          control={<Radio />}
                          label="C"
                        />
                        <FormControlLabel
                          value="D"
                          control={<Radio />}
                          label="D"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Box>
                </Fade>
              );
            }
            return null;
          })}
        </div>

        <div className="navigation-controls">
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <Button
              variant="outlined"
              onClick={() => setIsVisibleQuestion(prev => Math.max(1, prev - 1))}
              disabled={isVisibleQuestion === 1}
              startIcon={<ExpandLessIcon />}
            >
              Previous
            </Button>

            {isVisibleQuestion === base64.length ? (
              <Button
                variant="contained"
                color="primary"
                onClick={submitHandler}
                disabled={loaderVisible}
              >
                Submit Exam
              </Button>
            ) : (
              <Button
                variant="outlined"
                onClick={() => setIsVisibleQuestion(prev => Math.min(base64.length, prev + 1))}
                disabled={isVisibleQuestion === base64.length}
                endIcon={<ExpandMoreIcon />}
              >
                Next
              </Button>
            )}
          </Stack>
        </div>

        <div className="question-navigator">
          <Button
            variant="text"
            onClick={() => setShowNumbers(!showNumbers)}
          >
            Question Navigator
          </Button>
          
          {showNumbers && (
            <div className="question-numbers">
              {base64.map((_, index) => (
                <Button
                  key={index}
                  variant={isVisibleQuestion === index + 1 ? "contained" : "outlined"}
                  size="small"
                  onClick={() => setIsVisibleQuestion(index + 1)}
                  className={`question-number-btn ${
                    answer[index + 1] ? 'answered' : 'unanswered'
                  }`}
                >
                  {index + 1}
                </Button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TutorExam;

